import {
  BrandGroupService,
  type Brand,
  type BrandFeatureAvailability,
  type BrandMember,
  type BrandResourceAssignment,
  type BrandIntegrationAssignment,
} from '../brandGroupService';

export type Project = Brand;
export type ProjectMember = BrandMember;
export type ProjectResourceAssignment = BrandResourceAssignment;
export type ProjectIntegrationAssignment = BrandIntegrationAssignment;
export type ProjectFeatureAvailability = BrandFeatureAvailability;

/** Product-facing API names. The legacy service remains as a compatibility layer. */
export class ProjectService extends BrandGroupService {
  listProjects(workspaceId: string): Promise<Project[]> {
    return this.listBrands(workspaceId);
  }

  listIntegrationAssignmentProjects(workspaceId: string): Promise<Project[]> {
    return this.listIntegrationAssignmentBrands(workspaceId);
  }

  listTaskSelectableProjects(workspaceId: string): Promise<Project[]> {
    return this.listTaskSelectableBrands(workspaceId);
  }

  createProject(workspaceId: string, payload: Parameters<BrandGroupService['createBrand']>[1]): Promise<Project> {
    return this.createBrand(workspaceId, payload);
  }

  updateProject(workspaceId: string, projectId: string, payload: Parameters<BrandGroupService['updateBrand']>[2]): Promise<Project> {
    return this.updateBrand(workspaceId, projectId, payload);
  }

  deleteProject(workspaceId: string, projectId: string): Promise<void> {
    return this.archiveBrand(workspaceId, projectId);
  }
}

export const projectService = new ProjectService();
